export default __webpack_public_path__ + "static/Lilly2-04f93bfa227014cf5a3090c395c768b1.jpg";